module.exports = __webpack_public_path__ + "static/media/RAYAN ALHAMO.24080161.png";